import Navbar from '../components/navbar';
import About from '../sections/About';
import Project from '../sections/Project';
import Contact from '../sections/Contact';
import Footer from '../sections/Footer';
import Card from '../components/card';
import './Home.css';
const Home = () => {
  return (
    <div className="page">

      <Navbar />

      <section className="about" id="about">
        <About />
      </section>

      <section className="service" id="service">
        <h2 className="title">
          Ways I Can Help You
          <span className="title-line"></span>
        </h2>
        <Card />
      </section>

      <section className="portfolio" id="portfolio">
        <h2 className="title">
          Projects
          <span className="title-line"></span>
        </h2>
        <Project />
      </section>

      <section className="contact" id="contact">
        <Contact />
      </section>

      <Footer />

    </div>
  );
};

export default Home;